var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticStyle:{"text-align":"left"},attrs:{"justify":"center"}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return undefined}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }